@if (isLink()) {
    <a [routerLink]="routerLink()!" class="plan-badge__hit">
        {{ displayLabel() }}
    </a>
} @else {
    <span class="plan-badge__hit">{{ displayLabel() }}</span>
}
